/* ==========================================================================
   PDP Custom JS — Keravive Hair Priority Complex
   ========================================================================== */

(function() {
  'use strict';

  /* --- Countdown Timer --- */
  function initCountdown() {
    const el = document.querySelector('[data-pdp-countdown]');
    if (!el) return;
    const endDate = new Date(el.dataset.pdpCountdown).getTime();
    const days = el.querySelector('[data-days]');
    const hrs = el.querySelector('[data-hrs]');
    const mins = el.querySelector('[data-mins]');
    const secs = el.querySelector('[data-secs]');
    if (!days || !hrs || !mins || !secs) return;

    function update() {
      const now = Date.now();
      let diff = endDate - now;
      if (diff < 0) diff = 0;
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      days.textContent = String(d).padStart(2, '0');
      hrs.textContent = String(h).padStart(2, '0');
      mins.textContent = String(m).padStart(2, '0');
      secs.textContent = String(s).padStart(2, '0');
    }
    update();
    setInterval(update, 1000);
  }

  /* --- Image Gallery --- */
  function initGallery() {
    const mainImg = document.querySelector('[data-pdp-main-image]');
    const thumbs = document.querySelectorAll('[data-pdp-thumbnail]');
    if (!mainImg || !thumbs.length) return;

    /* Preload all product images to avoid flicker on swipe */
    thumbs.forEach(function(thumb) {
      var img = new Image();
      img.src = thumb.dataset.pdpThumbnail;
    });

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const src = this.dataset.pdpThumbnail;
        const srcset = this.dataset.pdpSrcset || '';
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        thumbs.forEach(function(t) { t.closest('.pdp-main-product__thumbnail').classList.remove('is-active'); });
        this.closest('.pdp-main-product__thumbnail').classList.add('is-active');
        var idx = Array.from(thumbDivs).indexOf(this.closest('.pdp-main-product__thumbnail'));
        if (idx >= 0) updateProgress(idx, thumbDivs.length);
      });
    });

    /* Progress bar */
    var progressFill = document.querySelector('[data-pdp-progress-fill]');
    function updateProgress(index, total) {
      if (!progressFill || total < 2) return;
      var pct = ((index + 1) / total) * 100;
      progressFill.style.width = pct + '%';
    }

    /* Scroll thumbnail strip to keep active thumb visible */
    var thumbStrip = document.querySelector('.pdp-main-product__thumbnails');
    function scrollToActiveThumb(index) {
      if (!thumbStrip || !thumbDivs[index]) return;
      var thumb = thumbDivs[index];
      var stripLeft = thumbStrip.scrollLeft;
      var stripWidth = thumbStrip.clientWidth;
      var thumbLeft = thumb.offsetLeft - thumbStrip.offsetLeft;
      var thumbWidth = thumb.offsetWidth;
      if (thumbLeft < stripLeft || thumbLeft + thumbWidth > stripLeft + stripWidth) {
        thumbStrip.scrollTo({ left: thumbLeft - (stripWidth / 2) + (thumbWidth / 2), behavior: 'smooth' });
      }
    }

    /* Thumbnail arrow navigation */
    var thumbArrowLeft = document.querySelector('[data-thumb-arrow="left"]');
    var thumbArrowRight = document.querySelector('[data-thumb-arrow="right"]');
    var thumbDivs = document.querySelectorAll('.pdp-main-product__thumbnail');
    var arrowBusy = false;

    function arrowNav(dir) {
      if (arrowBusy) return;
      arrowBusy = true;
      setTimeout(function() { arrowBusy = false; }, 300);

      var current = 0;
      for (var i = 0; i < thumbDivs.length; i++) {
        if (thumbDivs[i].classList.contains('is-active')) { current = i; break; }
      }
      var next = current + dir;
      if (next < 0) next = thumbDivs.length - 1;
      if (next >= thumbDivs.length) next = 0;

      var img = thumbDivs[next].querySelector('img');
      if (!img) { arrowBusy = false; return; }

      mainImg.src = img.dataset.pdpThumbnail;
      if (img.dataset.pdpSrcset) mainImg.srcset = img.dataset.pdpSrcset;
      for (var j = 0; j < thumbDivs.length; j++) thumbDivs[j].classList.remove('is-active');
      thumbDivs[next].classList.add('is-active');
      updateProgress(next, thumbDivs.length);
      scrollToActiveThumb(next);
    }

    if (thumbArrowLeft) {
      thumbArrowLeft.onclick = function(e) { e.preventDefault(); e.stopPropagation(); arrowNav(-1); };
    }
    if (thumbArrowRight) {
      thumbArrowRight.onclick = function(e) { e.preventDefault(); e.stopPropagation(); arrowNav(1); };
    }

    /* Touch swipe on main image for mobile */
    var imageMain = document.querySelector('.pdp-main-product__image-main');
    if (imageMain) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchMoved = false;

      imageMain.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
        touchMoved = false;
      }, { passive: true });

      imageMain.addEventListener('touchmove', function(e) {
        var dx = Math.abs(e.changedTouches[0].clientX - touchStartX);
        var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
        if (dx > dy && dx > 10) {
          touchMoved = true;
          e.preventDefault();
        }
      }, { passive: false });

      imageMain.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40 && touchMoved) {
          arrowNav(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    /* Lightbox */
    const lightbox = document.querySelector('.pdp-lightbox');
    const lightboxImg = lightbox ? lightbox.querySelector('.pdp-lightbox__image') : null;
    const lightboxClose = lightbox ? lightbox.querySelector('.pdp-lightbox__close') : null;
    const mainWrap = document.querySelector('.pdp-main-product__image-main');

    if (mainWrap && lightbox && lightboxImg) {
      mainWrap.addEventListener('click', function() {
        lightboxImg.src = mainImg.src;
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      if (lightboxClose) {
        lightboxClose.addEventListener('click', function() {
          lightbox.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }
      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox) {
          lightbox.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }
  }

  /* --- Bundle Options --- */
  function initBundleOptions() {
    /* Removed — now handled by Kaching Bundle app */
  }

  /* --- Sticky Buy Bar --- */
  function initStickyBar() {
    const bar = document.querySelector('.pdp-sticky-bar');
    const atcBtn = document.querySelector('.pdp-atc-btn');
    if (!bar || !atcBtn) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
        } else {
          bar.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(atcBtn);
  }

  /* --- Percentage Counter Animation --- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-pdp-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !entry.target.dataset.counted) {
          entry.target.dataset.counted = 'true';
          var target = parseInt(entry.target.getAttribute('data-pdp-counter-target'), 10) || 0;
          var duration = 1500;
          var startTime = null;

          function animate(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            entry.target.textContent = Math.floor(eased * target);
            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              entry.target.textContent = target;
            }
          }

          requestAnimationFrame(animate);
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(function(c) { observer.observe(c); });
  }

  /* --- Tab Switching --- */
  function initTabs() {
    var tabBtns = document.querySelectorAll('[data-pdp-tab-btn]');
    if (!tabBtns.length) return;

    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tabGroup = this.closest('[data-pdp-tabs]');
        if (!tabGroup) return;
        var target = this.dataset.pdpTabBtn;
        tabGroup.querySelectorAll('[data-pdp-tab-btn]').forEach(function(b) { b.classList.remove('is-active'); });
        tabGroup.querySelectorAll('[data-pdp-tab-content]').forEach(function(c) { c.classList.remove('is-active'); });
        this.classList.add('is-active');
        var content = tabGroup.querySelector('[data-pdp-tab-content="' + target + '"]');
        if (content) content.classList.add('is-active');
      });
    });
  }

  /* --- FAQ Accordion — handled by inline script in pdp-faq-accordion.liquid --- */
  function initAccordions() {
    /* No-op: FAQ accordion JS is in the section's inline script to avoid double-binding */
  }

  /* --- Subscribe Checkbox --- */
  function initSubscribe() {
    var checkbox = document.querySelector('.pdp-subscribe-option__checkbox');
    if (!checkbox) return;
    checkbox.addEventListener('click', function() {
      this.classList.toggle('is-checked');
    });
  }

  /* --- Add to Cart Form --- */
  function initATC() {
    var form = document.querySelector('[data-pdp-atc-form]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.pdp-atc-btn');
      var btnText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      var variantId = form.querySelector('[name="id"]').value;
      var qty = parseInt(form.querySelector('[name="quantity"]').value) || 1;

      var cartDrawer = document.querySelector('cart-drawer');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: qty }]
        })
      })
      .then(function(res) { return res.json(); })
      .then(function(response) {
        if (response.status) throw new Error(response.description || 'Add to cart failed');

        btn.textContent = 'Added!';
        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = btnText;
        }, 1500);

        if (!cartDrawer) {
          window.location.href = '/cart';
          return;
        }

        /* Fetch sections separately so they always reflect the updated cart */
        var sectionIds = cartDrawer.getSectionsToRender().map(function(s) { return s.id; }).join(',');
        return fetch(window.location.pathname + '?sections=' + sectionIds)
          .then(function(r) { return r.json(); })
          .then(function(sections) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents({ sections: sections });
          });
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = btnText;
      });
    });

    /* Sticky bar — scroll to bundle/main product section */
    var stickyBtn = document.querySelector('.pdp-sticky-bar__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var target = document.getElementById('main-product');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  /* --- Scroll to top CTA --- */
  function initScrollCTA() {
    var btns = document.querySelectorAll('[data-pdp-scroll-to]');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector(this.dataset.pdpScrollTo);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* --- Scroll-Reveal Animations --- */
  function initScrollReveal() {
    var sections = document.querySelectorAll('.animate-section.animate--hidden');
    if (!sections.length) return;

    /* Check for reduced motion preference */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach(function(section) {
        section.classList.remove('animate--hidden');
        section.classList.add('animate--shown');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('animate--hidden');
          entry.target.classList.add('animate--shown');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    sections.forEach(function(section) {
      observer.observe(section);
    });
  }

  /* --- Kaching Bundle Price Sync --- */
  function initBundlePriceSync() {
    var currentPriceEl = document.querySelector('[data-pdp-current-price]');
    var comparePriceEl = document.querySelector('[data-pdp-compare-price]');
    if (!currentPriceEl) return;

    function syncPrice(container) {
      var selected = container.querySelector('.kaching-bundles__bar--selected');
      if (!selected) return;
      var barPrice = selected.querySelector('.kaching-bundles__bar-price');
      var barFullPrice = selected.querySelector('.kaching-bundles__bar-full-price');
      if (barPrice) currentPriceEl.textContent = barPrice.textContent.trim();
      if (barFullPrice && comparePriceEl) comparePriceEl.textContent = barFullPrice.textContent.trim();
    }

    function attachToKaching(container) {
      var observer = new MutationObserver(function() { syncPrice(container); });
      observer.observe(container, { attributes: true, subtree: true, attributeFilter: ['class'] });
      container.addEventListener('click', function() {
        setTimeout(function() { syncPrice(container); }, 100);
      });
      /* Initial sync */
      syncPrice(container);
    }

    /* Wait for Kaching to load */
    var kc = document.querySelector('.kaching-bundles');
    if (kc) {
      attachToKaching(kc);
    } else {
      var bodyObserver = new MutationObserver(function() {
        var kc = document.querySelector('.kaching-bundles');
        if (kc) {
          bodyObserver.disconnect();
          attachToKaching(kc);
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  /* --- Init All --- */
  function init() {
    initCountdown();
    initGallery();
    initBundleOptions();
    initStickyBar();
    initCounters();
    initTabs();
    initAccordions();
    initSubscribe();
    initATC();
    initScrollCTA();
    initScrollReveal();
    initBundlePriceSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
